export default __webpack_public_path__ + "static/rec-2011-ii-0ad475db0f45b1c9a89072a5af28a2d1.png";